import { render } from "./StacksEditor.vue?vue&type=template&id=5fb248b4"
import script from "./StacksEditor.vue?vue&type=script&lang=js"
export * from "./StacksEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__